// Helpers thuần (không React) cho form push: build audience, rich options, payload,
// và map broadcast/template ngược về initialValues cho form. Giữ logic tách khỏi UI.

// ColorPicker (antd v5) trả về AggregationColor; cleared → null/string. Chuẩn hóa về hex string.
export function normalizeColor(color) {
    if (!color) return undefined;
    if (typeof color === "string") return color.trim() || undefined;
    if (typeof color.toHexString === "function") return color.toHexString();
    return undefined;
}

export function buildAudience(mode, selectedRoles, rawIds, criteria) {
    if (mode === "all") return { mode: "all", onlyWithActivePushSubscription: true };
    if (mode === "roles") return { mode: "roles", roles: selectedRoles, onlyWithActivePushSubscription: true };
    if (mode === "ids") {
        const userIds = String(rawIds || "")
            .split(/[\s,\n]+/)
            .map((s) => parseInt(s.trim(), 10))
            .filter((n) => n > 0);
        return { mode: "ids", userIds, onlyWithActivePushSubscription: true };
    }
    const f = { mode: "criteria", onlyWithActivePushSubscription: true };
    if (criteria.platform) f.platform = criteria.platform;
    if (criteria.active !== undefined && criteria.active !== "") {
        f.active = criteria.active === "true" || criteria.active === true;
    }
    if (criteria.joinedAfter) f.joinedAfter = criteria.joinedAfter;
    if (criteria.joinedBefore) f.joinedBefore = criteria.joinedBefore;
    return f;
}

// Chỉ giữ field có giá trị (khớp logic truthiness của BE → không gửi chuỗi rỗng).
export function buildRichOptions(values = {}) {
    const o = {};
    if (values.image && String(values.image).trim()) o.image = String(values.image).trim();
    if (values.icon && String(values.icon).trim()) o.icon = String(values.icon).trim();
    const color = normalizeColor(values.color);
    if (color) o.color = color;
    if (values.badge != null && values.badge !== "") o.badge = Number(values.badge);
    if (values.priority === "normal" || values.priority === "high") o.priority = values.priority;
    if (values.silent === true) o.silent = true;
    if (values.ttl != null && values.ttl !== "") o.ttl = Number(values.ttl);
    if (values.collapseKey && String(values.collapseKey).trim()) o.collapseKey = String(values.collapseKey).trim();
    return o;
}

// Gộp payload gửi broadcast/test/lưu template. scheduledAt (epoch ms) tùy chọn.
/**
 * @param deliveryMode "queue" (mặc định) hoặc "topic". Chỉ gửi lên khi là "topic" —
 *        để mọi lời gọi cũ không đổi hành vi, và BE tự mặc định về "queue".
 */
export function buildPayload(values, audience, scheduledAt, deliveryMode) {
    return {
        title: values.title,
        message: values.message,
        path: values.path || undefined,
        url: values.url || undefined,
        audience,
        ...buildRichOptions(values),
        ...(scheduledAt ? { scheduledAt } : {}),
        ...(deliveryMode === "topic" ? { sendMode: "topic" } : {}),
    };
}

// Cột audiencePayload ở DB là longtext (không phải JSON native) → mysql2 có thể
// trả về chuỗi. Parse phòng thủ về object để hiển thị/seed lại đúng.
export function asObject(raw) {
    if (!raw) return {};
    if (typeof raw === "object") return raw;
    if (typeof raw === "string") {
        try { return JSON.parse(raw); } catch { return {}; }
    }
    return {};
}

// pushOptions lưu ở DB ({imageUrl,...}) → fields phẳng cho form (image,...).
export function pushOptionsToFields(pushOptions = {}) {
    const o = pushOptions || {};
    return {
        image: o.imageUrl || undefined,
        icon: o.icon || undefined,
        color: o.color || undefined,
        badge: o.badge != null ? o.badge : undefined,
        priority: o.priority || "high",
        silent: o.silent === true,
        ttl: o.ttl != null ? o.ttl : undefined,
        collapseKey: o.collapseKey || undefined,
    };
}

// Map 1 broadcast (resend) hoặc template (load) về initialValues nội dung cho form.
export function contentToFields(src = {}) {
    return {
        title: src.title,
        message: src.message,
        path: src.openPath || undefined,
        url: src.openUrl || undefined,
        ...pushOptionsToFields(src.pushOptions),
    };
}
